import React from "react"
import { type Sport } from "hooks"

import Game from "compositions/events/Game/Game"

type UniqueEventsProps = {
  leagues: Sport["leagues"]
}

const UniqueEvents: React.FC<UniqueEventsProps> = ({ leagues }) => {
  return (
    <div className="space-y-px">
      {leagues.map(({ countrySlug, slug, games }, leagueIndex) => {
        const leagueUrl = `/unique/${countrySlug}/${slug}`

        return games.map((game, gameIndex) => (
          <Game
            key={`${leagueUrl}/${game.gameId}`}
            leagueUrl={leagueUrl}
            game={game}
            isUnique
            isFirstGame={leagueIndex === 0 && gameIndex === 0}
          />
        ))
      })}
    </div>
  )
}

export default UniqueEvents
